import { render, staticRenderFns } from "./NtagLocationRow.vue?vue&type=template&id=0b3450c0&scoped=true&"
import script from "./NtagLocationRow.vue?vue&type=script&lang=ts&"
export * from "./NtagLocationRow.vue?vue&type=script&lang=ts&"
import style0 from "./NtagLocationRow.vue?vue&type=style&index=0&id=0b3450c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3450c0",
  null
  
)

export default component.exports